import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_input = _resolveComponent("b-input")!
  const _component_BFieldHint = _resolveComponent("BFieldHint")!
  const _component_b_select = _resolveComponent("b-select")!
  const _component_WebhookForm = _resolveComponent("WebhookForm")!

  return (_openBlock(), _createBlock(_component_WebhookForm, {
    id: _ctx.id,
    initial: _ctx.effectiveInitial,
    "visibility-config": _ctx.visibilityConfig,
    onSaved: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('saved')))
  }, {
    parameters: _withCtx(({ getSecret, setSecret, getParam, setParam }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('ifttt.settings')), 1),
        _createVNode(_component_BFieldHint, {
          label: _ctx.$t('ifttt.eventName'),
          hintKey: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_input, {
              "model-value": getParam('IFTTT_EVENT_NAME'),
              placeholder: _ctx.$t('ifttt.eventNamePlaceholder'),
              "onUpdate:modelValue": val => setParam('IFTTT_EVENT_NAME', val)
            }, null, 8, ["model-value", "placeholder", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1032, ["label"]),
        _createVNode(_component_BFieldHint, {
          label: _ctx.$t('ifttt.apiKey'),
          hintKey: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_select, {
              "model-value": getSecret('IFTTT_KEY'),
              placeholder: _ctx.$t('ifttt.selectSecret'),
              "onUpdate:modelValue": val => setSecret('IFTTT_KEY', String(val))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secretOptions, (name) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: name,
                    value: name
                  }, _toDisplayString(name), 9, _hoisted_3))
                }), 128))
              ]),
              _: 1
            }, 8, ["model-value", "placeholder", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1032, ["label"])
      ])
    ]),
    _: 1
  }, 8, ["id", "initial", "visibility-config"]))
}